import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import type { AgreementImportRecordStatus } from '@client/api';

const STATUS_COLOR: Record<AgreementImportRecordStatus, string> = {
  Pending: 'text-white/60',
  NeedsReview: 'text-amber-400',
  Approved: 'text-teal-400',
  Rejected: 'text-red-400',
};

export function ContractStatusBadge({ status }: { status: AgreementImportRecordStatus }) {
  const { t: tAgreements } = useTranslation('agreements');

  return (
    <span className={classNames('font-medium', STATUS_COLOR[status])}>
      {tAgreements(`agreementImport.status.${status}`)}
    </span>
  );
}
